import React, { FunctionComponent} from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import SoldOut from "assets/Icons/SoldOut.svg";

const style = require('./Box.css')
import locale from './locale'

interface Props {
  key: Number,
  date: String,
  time: String,
  isOnSale: Boolean,
  handleClick: () => void,
  selected: Boolean,
}

const BoxComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  date,
  time,
  isOnSale,
  handleClick,
  selected,
  intl: { formatMessage },
}) => {
  const timeSlotUnavailable = !isOnSale

  const getContainerClass = () => (
    selected
    ? `${style.container} ${style.selected}`
    : style.container
  )

  return (
    <button className={getContainerClass()} disabled={timeSlotUnavailable} onClick={handleClick}>
      <div className={style.content}>
        <div className={style.date}>{date}</div>
        <div className={style.time}>{time}</div>
      </div>
    </button>
  )
}

export const Box = injectIntl(BoxComponent)
